const MONEY_FORMAT = '${{amount}}';
const format = function(t = 0, e = 2, o = ',', i = '.') {
    if (isNaN(t)) {
        return '0';
    }
    const r = (t / 100).toFixed(e).split('.');
    const part = r[0] || '';
    return part.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + o) + (r[1] ? i + r[1] : '');
};
const r = /\{\{\s*(\w+)\s*\}\}/;
export const formatMoney = function(t, e = MONEY_FORMAT) {
    const a = e || MONEY_FORMAT;
    const foundMatches = a.match(r);
    if (!foundMatches) {
        throw new Error('Money template has no `{{amount}}` placeholder');
    }
    const formatName = foundMatches[1];
    const i = formatName === 'amount' ? format(t, 2) : formatName === 'amount_no_decimals' ? format(t, 0) : formatName === 'amount_with_comma_separator' ? format(t, 2, '.', ',') : formatName === 'amount_with_space_separator' ? format(t, 2, ' ', ',') : formatName === 'amount_with_period_and_space_separator' ? format(t, 2, ' ', '.') : formatName === 'amount_no_decimals_with_comma_separator' ? format(t, 0, '.', ',') : formatName === 'amount_no_decimals_with_space_separator' ? format(t, 0, ' ') : formatName === 'amount_with_apostrophe_separator' ? format(t, 2, "'", '.') : t.toString(10);
    return a.replace(r, i);
};
